const images = {
    logo: require('./logoHeaderTransparent.png'),
};

export default images;



// WEBPACK FOOTER //
// ./src/assets/images/images.js